import { CloseSvg } from "@callveriq/components/svg";
import { alpha, Box, Typography, useTheme } from "@mui/material";

export const ViewBlockHeader = ({
    icon,
    title,
}: {
    icon: React.ReactNode;
    title: string;
}) => {
    const theme = useTheme();
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flex: 1,
                p: 2,
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                color: theme.palette.primary.main,
            }}
        >
            <div className="flex items-center gap-2">
                {icon}
                <Typography>{title}</Typography>
            </div>
            <div className="flex items-center gap-2 view_block_close_button nodrag nopan cursor-pointer">
                <CloseSvg
                    sx={{ color: "textColors.333" }}
                    className="pointer-events-none"
                />
            </div>
        </Box>
    );
};
